import { useMemo, useReducer } from 'react';

import { childVisibilityReducer } from '../ScrollingCarousel.helpers';
import type { CarouselContextType } from '../ScrollingCarousel.types';

type UseCarouselVisibilityReturn = {
  state: {
    childVisibility: boolean[];
  };
  carouselContextApi: CarouselContextType;
  firstVisibleIndex: number;
  lastVisibleIndex: number;
  firstItemIsVisible: boolean;
  lastItemIsVisible: boolean;
  anyItemsVisible: boolean;
};

/**
 * Hook for managing carousel child visibility state
 */
export const useCarouselVisibility = (
  carousel: React.RefObject<HTMLDivElement>
): UseCarouselVisibilityReturn => {
  const [state, dispatch] = useReducer(childVisibilityReducer, {
    childVisibility: [],
  });

  const carouselContextApi = useMemo<CarouselContextType>(
    () => ({ carousel, dispatch }),
    [carousel]
  );

  const firstVisibleIndex = state.childVisibility.indexOf(true);
  const firstItemIsVisible = firstVisibleIndex === 0;
  const lastVisibleIndex = state.childVisibility.lastIndexOf(true);
  const lastItemIsVisible =
    lastVisibleIndex === state.childVisibility.length - 1;
  const anyItemsVisible = !!(firstVisibleIndex >= 0 && lastVisibleIndex >= 0);

  return {
    state,
    carouselContextApi,
    firstVisibleIndex,
    lastVisibleIndex,
    firstItemIsVisible,
    lastItemIsVisible,
    anyItemsVisible,
  };
};
